import { Signal, Type } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

export const BOTTOM_MENU_ITEM_IDS = {
    CHAT_PANEL: 'interacta-bmi-chat-panel',
    AI_FAB: 'interacta-bmi-ai-fab',
    BULK_WORKFLOW_TRANSITION_BANNER:
        'interacta-bmi-bulk-workflow-transition-banner',
    UPLOAD_DIALOG: 'interacta-bmi-upload-dialog',
    I_LAB_RECORDER: 'interacta-i-lab-recorder',
} as const;

export type BottomMenuItemId =
    (typeof BOTTOM_MENU_ITEM_IDS)[keyof typeof BOTTOM_MENU_ITEM_IDS];

export type BottomMenuItemType = Type<unknown>;

export type BottomMenuItem = {
    id: BottomMenuItemId;
    type: BottomMenuItemType;
    isOpen: Signal<boolean>;
};

export class BottomMenuState {
    components$ = new BehaviorSubject<BottomMenuItem[]>([]);
}
